import { Icon } from "@silversea-ssc/ui-components-react";
import React from "react";
import "./BarCheckbox.scss";

export interface BarCheckboxProps {
  disabled?: boolean;
  checked?: boolean;
  label: string;
  count?: number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const BarCheckbox: React.FC<BarCheckboxProps> = ({
  disabled,
  checked,
  label,
  count,
  onChange
}) => {
  let labelWithCounter = label;
  if (count && count > 0) labelWithCounter = `${label} (${count})`;

  return (
    <div className="ssc-bar-checkbox">
      <label className="ssc-bar-checkbox--label">
        <input
          className="ssc-bar-checkbox--input"
          type="checkbox"
          disabled={disabled}
          checked={checked}
          onChange={onChange}
        />
        <span className="ssc-bar-checkbox--label-text">{labelWithCounter}</span>
        <Icon
          name="check"
          size="1.5x"
          padding={false}
          className="ssc-bar-checkbox--icon"
        />
      </label>
    </div>
  );
};

export default BarCheckbox;
